module Dashboard{
    angular
        .module('dashboard')
        .directive('elastic', ($timeout): ng.IDirective => {

            return {
                restrict: 'A',
                link($scope, element, attrs: any) {
                    let initialHeight = element[0].style.height;
                    const maxRows = $scope.$eval(attrs.elastic);
                    const maxHeight = (element[0].clientHeight - 18) * maxRows;
                    const resize = _.debounce(function () {
                        element[0].style.height = initialHeight;
                        element[0].style.height = (maxHeight <= element[0].scrollHeight ?
                            maxHeight : element[0].scrollHeight) + 'px';
                    }, 250);
                    element.on('input change',resize);
                    $timeout(resize, 0);
                }
            };

        });
}
